import { getOrdersOrderIdChargesSum } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useQuery } from "@tanstack/react-query";

export const getOrderChargesSumQueryKey = (orderId: number) => [
	"ORDER_CHARGES_SUM",
	orderId,
];

export function useOrderChargesSumQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderChargesSumQueryKey(orderId),
		queryFn: processResponse(() => getOrdersOrderIdChargesSum(orderId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId && hasPermission(UserPermissions.OrderChargeModule.read),
	});
}
